import React from 'react'
import { StepIconProps } from '@mui/material/StepIcon'
import { makeStyles } from 'tss-react/mui'

const StepIcon = (props: StepIconProps) => {
  const { active, completed } = props
  const { classes, cx } = useStyles()

  return (
    <div
      className={cx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      <div className={classes.circle} />
    </div>
  )
}

export default StepIcon

const useStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.background.default,
    display: 'flex',
    height: 22,
    alignItems: 'center',
    flexShrink: 0,
  },
  active: {
    color: theme.palette.primary.main,
  },
  completed: {
    color: theme.palette.primary.main,
  },
  circle: {
    width: 18,
    height: 18,
    borderRadius: '50%',
    border: '2px solid white',
    zIndex: 1,
    backgroundColor: 'currentColor',
  },
}))
